import { BackendError } from '@oresundsbron/api';
import {
  PrivateITicketOrderInputV2,
  PrivateITicketOrderResponse,
} from '@oresundsbron/validators';
import create from 'zustand';

export type PrivateITicketStoreData = {
  data?: PrivateITicketOrderInputV2;
  response?: PrivateITicketOrderResponse;
  error?: BackendError;
};

export const usePrivateITicketData = create<PrivateITicketStoreData>(
  () => ({})
);

export const setData = (data: PrivateITicketOrderInputV2) => {
  return usePrivateITicketData.setState(() => ({ data }));
};

export const setResponse = (response: PrivateITicketOrderResponse) => {
  return usePrivateITicketData.setState((prevState) => ({
    ...prevState,
    response,
  }));
};

export const setError = (error?: BackendError) =>
  usePrivateITicketData.setState((state) => ({
    ...state,
    error,
    resp: undefined,
  }));

export const resetStore = () =>
  usePrivateITicketData.setState(() => ({
    error: undefined,
    data: undefined,
    response: undefined,
  }));
